import { Component, HostBinding, OnInit, OnDestroy, Input, ElementRef, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NavigationService } from '../navigation.service';
import { DomSanitizer } from '@angular/platform-browser';
import { staticInOut } from '../router.animations';
import { pick, orderBy, assign, forEach } from 'lodash';
import { LayoutService } from '../layout.service';
import { ImageGalleryService } from '../image-gallery.service';

@Component({
  selector: 'app-default-page-view',
  templateUrl: './default-page-view.component.html',
  styleUrls: ['./default-page-view.component.scss'],
  host: {
    '[@staticInOut]': ''
  },
  animations: [
    staticInOut
  ]
})
export class DefaultPageViewComponent implements OnInit, OnDestroy {
  @Input() apiData;
  @Input() isLoadingApiData;
  title: string;
  soundbite: string;
  rows: any[];
  selectedImage: any;
  isGalleryOpen: boolean;
  isPageLoaded: boolean = false;
  locationSubscription: any;
  imageGallerySubscriptionClose: any;

  get scrollTop() {
    return this.elRef.nativeElement.scrollTop || document.body.scrollTop;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private sanitizer: DomSanitizer,
    private LayoutService: LayoutService,
    private NavigationService: NavigationService,
    private elRef: ElementRef,
    private ImageGalleryService: ImageGalleryService
  ) { }

  ngOnInit() {
    this.imageGallerySubscriptionClose = this.ImageGalleryService.onClose.skip(1).subscribe(evt => {
      this.setToPreviousScrollTop();
    });

    // On back need to check if need to close or open image gallery, or change image
    this.locationSubscription = this.location.subscribe((e) => {
      setTimeout(() => {
        this.setGalleryState();
      });
    });
  }

  ngOnDestroy() {
    if (this.isPageLoaded) {
      this.LayoutService.saveGridScrollPosition(this.apiData.id, this.scrollTop);
    }
    if (typeof this.imageGallerySubscriptionClose !== 'undefined') {
      this.imageGallerySubscriptionClose.unsubscribe();
    }
    if (typeof this.locationSubscription !== 'undefined') {
      this.locationSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.apiData !== 'undefined' && changes.apiData.currentValue) {
      this.initPage();
    }
  }

  initPage() {
    let projectData: any = pick(this.apiData, ['title', 'soundbite', 'rows']);
    projectData.rows = orderBy(projectData.rows, ['position'], ['asc']);
    assign(this, projectData);
    
    this.setGalleryState();
  }

  setGalleryState() {
    // Timeout to prevent "Expression has changed after it was checked" exeption
    // on image gallery component within view-with-nav-bar
    setTimeout(() => {
      const idMatch = /\/image\/(\d+)/.exec(window.location.pathname);
      // Gallery image id defined in url
      if (idMatch !== null) {
        const selectedImage = this.getSelectedImage(+idMatch[1]);
        // Valid image id
        if (typeof selectedImage !== 'undefined') {
          this.ImageGalleryService.openSingleGallery(selectedImage);
        // Not valid image id
        } else {
          this.router.navigate([`../../`], {relativeTo: this.route});
        }

      // Gallery image id is not defined in url
      // but gallery is open
      } else if (this.ImageGalleryService.isGalleryOpen) {
        this.ImageGalleryService.closeGallery();
      }
    });
  }

  getSelectedImage(imageId) {
    let selectedImageRow;
    forEach(this.rows, (row) => {
      if (typeof row.single_content_id !== 'undefined' && row.single_content_type === 'content_images' && row.single_content[0].image_id === imageId) {
        selectedImageRow = row.single_content[0].image;
        return false;
      } else if (typeof row.left_content_id !== 'undefined' && row.left_content_type === 'content_images' && row.left_content[0].image_id === imageId) {
        selectedImageRow = row.left_content[0].image;
        return false;
      } else if (typeof row.right_content_id !== 'undefined' && row.right_content_type === 'content_images' && row.right_content[0].image_id === imageId) {
        selectedImageRow = row.right_content[0].image;
        return false;
      }
    });
    return selectedImageRow;
  }

  onImageClick(imageId) {
    this.LayoutService.saveGridScrollPosition(this.apiData.id, this.scrollTop);
    const selectedImage = this.getSelectedImage(imageId);
    this.ImageGalleryService.openSingleGallery(selectedImage);
  }

  isContentLoaded() {
    this.isPageLoaded = true;
    if (this.NavigationService.isBack) {
      this.setToPreviousScrollTop();
    }
  }

  setToPreviousScrollTop() {
    setTimeout(() => {
      this.elRef.nativeElement.scrollTop = this.LayoutService.getGridScrollPosition(this.apiData.id);
      document.body.scrollTop = this.LayoutService.getGridScrollPosition(this.apiData.id);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/default-page-view/default-page-view.component.ts